require('src/creative/core-page/submodel-selector/submodel-selector.scss');
var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');

// Constants, yup
var EVENT_SUBMODEL_CHANGED = 'submodel-changed';
// Dom Objects, check
var subSelector, ssButton, ssDropDown, ssSubmodelLabel;

//
// Helper Functions
//
function init() {
    // Do some some finding work.
    subSelector = document.querySelector('.submodel-selector');
    ssButton = subSelector.querySelector('.change-selector');
    ssDropDown = subSelector.querySelector('.submodel-dropdown');
    ssSubmodelLabel = subSelector.querySelector('.submodel-label');

    // Remove interactivty if only one submodel.
    if (ssDropDown) { // Remove Submodel Selector Dropdown button if only one submodel is available
        var allListElements = ssDropDown.querySelectorAll('ul li');
        if (allListElements.length < 2) {
            ssButton.style.display = 'none';
        }
    }

    // Add Event Handlers
    addEventHandlers();

}

// Update location with core page url appended with submodel
function pushURL(url) {
    if (url) {
        //window.history.pushState(null, null, url);
        window.location.href = url;
    }
}

// Update DOM elements after submodel change
function handleSubmodelChange(e, data) {
    if (e && data.submodelType) {
        if (ssSubmodelLabel) {
            ssSubmodelLabel.innerHTML = data.submodelDisplayName;
        }
    }
}

// Yes, I am reinventing the wheel. Don't hate
Element.prototype.findClosest = function(findElement) {
    var goodElement = this;
    while (goodElement.nodeName !== findElement.toUpperCase()) {
        if (goodElement.nodeName === 'HTML') {
            return false;
        }
        goodElement = goodElement.parentNode;
    }
    return goodElement;
};

//
// Event Handlers
//
function addEventHandlers() {
    // Listen for submodel-changed event and do something
    eventToolbox.subscribeCustomEvent(EVENT_SUBMODEL_CHANGED, handleSubmodelChange);

    // Handle opening and closing Submodel Selector Drop down
    if (ssButton) {
        ssButton.addEventListener('click', function() {
            ssButton.classList.toggle('open');
            if (ssDropDown) {
                ssDropDown.classList.toggle('open');
            }
        });
    }

    // Handle submodel selection
    if (ssDropDown) {
        ssDropDown.addEventListener('click', function(e) {
            e.preventDefault();
            //retrieve the submodel type of vehicle selected
            var data = e.target.findClosest('li').getAttribute('data-submodel-type').split(':');
            var url = e.target.findClosest('a').href;
            var submodelType = data[0];
            var submodelDisplayName = data[1];

            // Collapse dropdown and fire "submodel-changed" event
            if (submodelType && submodelDisplayName) {
                ssDropDown.classList.toggle('open');
                eventToolbox.fireCustomEvent(EVENT_SUBMODEL_CHANGED, {
                    submodelType: submodelType,
                    submodelDisplayName: submodelDisplayName
                });
                pushURL(url);
            }
        });
    }

}

init();



//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/submodel-selector/submodel-selector.js
// module id = 93
// module chunks = 0 1 3 6 8 11 12 14